var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 442.04 86.31",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4540df;}.cls-2{fill:#9b52e8;}.cls-3{fill:#88e8d8;}.cls-4{fill:#2a2b6d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.58,63.53V1.2A1.2,1.2,0,0,0,20.38,0H1.2A1.2,1.2,0,0,0,0,1.2V85.11a1.2,1.2,0,0,0,1.2,1.2H85.11a1.2,1.2,0,0,0,1.2-1.2V65.93a1.2,1.2,0,0,0-1.2-1.2H22.78A1.2,1.2,0,0,1,21.58,63.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.36,1.2V15a1.2,1.2,0,0,0,1.2,1.2H68.93a1.19,1.19,0,0,1,1.19,1.2V52.74a1.2,1.2,0,0,0,1.2,1.2H85.11a1.2,1.2,0,0,0,1.2-1.2V1.2A1.2,1.2,0,0,0,85.11,0H33.56A1.2,1.2,0,0,0,32.36,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.36,28.17v8.39a1.2,1.2,0,0,0,1.2,1.2H47.35a1.2,1.2,0,0,1,1.2,1.2V52.74a1.2,1.2,0,0,0,1.2,1.2h8.39a1.2,1.2,0,0,0,1.2-1.2V28.17a1.2,1.2,0,0,0-1.2-1.2H33.56A1.2,1.2,0,0,0,32.36,28.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M155.91,64V75.63H118.4V10.79h12.5V64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M209.82,56.73H175c1.67,6.3,6.86,9.64,13.34,9.64a13.72,13.72,0,0,0,10.47-4.63l9.45,5.55c-3.8,5.28-11,9.54-19.92,9.54-15.56,0-25.84-10.37-25.84-24.64,0-14.72,11-24.64,24-24.64C200.65,27.55,212,38.21,209.82,56.73Zm-11.48-9.07C197.13,41.54,193,38,186.66,38c-5.74,0-10.28,3.61-11.67,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M232.79,39.41V56.55c0,5.37.75,8.52,7.23,8.52a26.14,26.14,0,0,0,2.78-.19V75.63a15.23,15.23,0,0,1-4.91.65c-12,0-16.86-8.06-16.86-17.79V39.41h-6.67V28.67H221V18.85h11.76v9.82h10V39.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M289,61.18c0,9.26-6.76,15.65-19.92,15.65-9,0-18.06-3.61-20.19-11.48l11.3-3.52c.37,1.94,2.23,5.09,9.08,5.09,4.91,0,7.69-1.76,7.69-4.91,0-4.44-6.76-4.26-12.32-5.46C255.58,54.7,251,50.34,251,42.28c0-8.89,7.41-14.73,18.43-14.73,8.06,0,16,4,18,12.14L276.7,42.28c-.56-2.41-2.87-4.81-7.32-4.81-3.42,0-6.94,1.29-6.94,4.81,0,4.17,6.29,4.45,10,5.28C283.93,50.06,289,53.21,289,61.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M348.3,10.79,325,75.63H309.49L286.24,10.79h13.25l17.78,52.15L335,10.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M389.06,52.19a24.78,24.78,0,0,1-49.56,0,24.78,24.78,0,0,1,49.56,0Zm-12,0c0-7.31-4.91-13.34-12.78-13.34s-12.69,6-12.69,13.34,4.91,13.34,12.69,13.34S377,59.51,377,52.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M442,52.19a24.78,24.78,0,0,1-49.55,0,24.78,24.78,0,0,1,49.55,0Zm-12,0c0-7.31-4.91-13.34-12.78-13.34s-12.69,6-12.69,13.34,4.91,13.34,12.69,13.34S430,59.51,430,52.19Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.4526a33a.svg";
export { ForwardRef as ReactComponent };